var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", { staticClass: " flex-fill member-search-area" }, [
          _c("div", { staticClass: "d-flex search-text-area" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.period,
                    expression: "period",
                  },
                ],
                staticClass: "mr-05",
                attrs: { name: "period", id: "period" },
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.period = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.showByPeriod,
                  ],
                },
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v(_vm._s(_vm.__("search.filter"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "1" } }, [
                  _vm._v(_vm._s(_vm.__("search.1_day"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "7" } }, [
                  _vm._v(_vm._s(_vm.__("search.7_day"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "14" } }, [
                  _vm._v(_vm._s(_vm.__("search.14_day"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "30" } }, [
                  _vm._v(_vm._s(_vm.__("search.30_day"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "60" } }, [
                  _vm._v(_vm._s(_vm.__("search.60_day"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "90" } }, [
                  _vm._v(_vm._s(_vm.__("search.90_day"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keyword,
                  expression: "keyword",
                },
              ],
              staticClass: "form-control input-search",
              attrs: {
                type: "text",
                placeholder:
                  "Search for another subscriber by their name, position or organisation...",
              },
              domProps: { value: _vm.keyword },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.keyword = $event.target.value
                  },
                  function ($event) {
                    _vm.isTyping = true
                  },
                ],
              },
            }),
            _vm._v(" "),
            _c("button", { staticClass: "btn-member-search btn btn-primary" }, [
              _vm._v(_vm._s(_vm.__("globals.search"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex filter-letter-index" },
            _vm._l(_vm.filterOptions, function (letter) {
              return _c("div", { staticClass: "filter-options" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-uppercase font-weight-bold",
                    class: { active: _vm.selectedFilter === letter.key },
                    on: {
                      click: function ($event) {
                        return _vm.filterMemberResults(letter.key)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(letter.value) +
                        "\n                    "
                    ),
                  ]
                ),
              ])
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row match-height" },
        _vm._l(_vm.members, function (member, index) {
          return _c(
            "div",
            { key: index, staticClass: "col-lg-6 col-md-6 col-sm-6" },
            [
              _c("member-directory-card", {
                attrs: { member: member, index: index },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: { spinner: "spiral", identifier: _vm.infiniteId },
          on: {
            distance: function ($event) {
              1
            },
            infinite: _vm.infiniteHandler,
          },
        },
        [
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }, [
            _vm._v(_vm._s(_vm.__("globals.no_more_members"))),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }),
        ]
      ),
      _vm._v(" "),
      _vm.members.length === 0
        ? _c("div", [
            _vm._v(_vm._s(_vm.__("globals.no_members_found")) + "\n        "),
            _vm.searchForFirstLetter
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.starting_with")) + " "),
                  _c("strong", [_vm._v(_vm._s(_vm.selectedFilter))]),
                ])
              : _vm._e(),
            _vm._v(".\n    "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }